export default __webpack_public_path__ + "static/media/numbersearch_locked.06936c7a.svg";